<template>
  <div class="copyright_services">
    <my-head></my-head>
    <div class="top">
      <img src="../assets//copyright_services/top.png" alt="">
    </div>
    <div class="copyright minH margin-auto">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">版权服务</span>
      </div>

      <div class="title">打造版权专区 助力产业升级</div>

      <div class="list">
        <div class="lamborghini_models" @click="lamborghini(item.id)" v-for="(item, index) in list" :key="index">
          <img :src="item.zoneImage" alt="">
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import { getRequest } from "../api/api";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      list: []
    };
  },
  watch: {
    // nespage: {
    //   handler() {
    //     this.copyright();
    //   },
    //   deep: true,
    // },
  },
  methods: {
    // 兰博基尼
    lamborghini(id) {
      this.$router.push({
        path: "/lamborghini",
        query: { id }
      });
    },
    zoneList() {
      //产权类型+交易类型+翻页筛选
      let data = {
        // page: 1,
        // size: 10,
      };

      getRequest({ url: "/api/v1/zone/list" }).then((res) => {
        if (res.errcode == 200) {
          this.list = res.data;
        }
      });
    },

  },
  created() {
    this.zoneList()
  },
};
</script>

<style lang="scss">
.copyright_services {
  .top {
    width: 100%;
    margin-bottom: 48px;

    img {
      width: 100%;
    }
  }

  .copyright {
    width: 80%;
    padding-bottom: 48px;
  }

  .title {
    font-size: 30px;
    font-weight: bold;
    color: #1D2129;
    line-height: 38px;
    text-align: center;
  }

  .list {
    width: 100%;
    margin-top: 60px;

    .lamborghini_models {
      cursor: pointer;
      margin-bottom: 30px;

      img {
        width: 100%;
      }
    }

    .other {
      margin-top: 32px;
      margin-bottom: 74px;
      cursor: pointer;

      img {
        width: 100%;
      }

    }
  }


}



.copyright {
  width: 80%;
  padding-bottom: 48px;
}
</style>
